import * as PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TextField from '../../../../../../components/TextField';
import variables from '../../../../../../utils/variables';
import { unicodeToChar } from '../../../../../../utils/unicode';
import { setCollectionDescription } from '../../../../../../actions/createAssets';
import WarningIcon from '../../../../../../assets/library/info_warning.svg';

const DescriptionTextField = (props) => {
    const handleChange = (value) => {
        if (value.length > 250) {
            props.onChange(value, false);
        } else {
            props.onChange(value, true);
        }
    };

    return (
        <div className="description_field">
            <TextField
                multiline
                className="text_area"
                error={!props.valid}
                // errorText={!props.valid ? variables[props.lang]['description_error_250'] : ''}
                id="description"
                name="description"
                placeholder={variables[props.lang]['collection_placeholder_description']}
                value={props.value && unicodeToChar(props.value)}
                onChange={handleChange}/>
            <div className={props.value && props.value.length
                ? (props.value.length > 250
                    ? 'error_description description_count'
                    : props.value.length > 250 / 2
                        ? 'description_count green_text'
                        : 'description_count orange_text')
                : 'description_count'}>
                {props.value && props.value.length
                    ? props.value.length > 250
                        ? <>
                            <img alt="info" src={WarningIcon}/>
                            {variables[props.lang].character_limit_exceeded}
                        </>
                        : ''
                    : variables[props.lang].maximum}
                <p>{props.value && props.value.length ? `${props.value.length}/` : ''}{250}</p>
                <p>{props.value && props.value.length ? '' : variables[props.lang].characters}</p>
            </div>
        </div>
    );
};

DescriptionTextField.propTypes = {
    lang: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        valid: state.createAssets.createCollection.descriptionValid,
        value: state.createAssets.createCollection.description,
    };
};

const actionsToProps = {
    onChange: setCollectionDescription,
};

export default connect(stateToProps, actionsToProps)(DescriptionTextField);
